export default __webpack_public_path__ + "static/media/arrow-right-green.7d9e6ceb.svg";